import { render } from "./ListPeriodoActivo.vue?vue&type=template&id=3ad5551e"
import script from "./ListPeriodoActivo.vue?vue&type=script&lang=js"
export * from "./ListPeriodoActivo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__